import Cookies from 'js-cookie'

// App
const sidebarStatusKey = 'sidebar_status'
export const getSidebarStatus = () => Cookies.get(sidebarStatusKey)
export const setSidebarStatus = (sidebarStatus: string) => Cookies.set(sidebarStatusKey, sidebarStatus)

const languageKey = 'language'
export const getLanguage = () => Cookies.get(languageKey)
export const setLanguage = (language: string) => Cookies.set(languageKey, language)

const sizeKey = 'size'
export const getSize = () => Cookies.get(sizeKey)
export const setSize = (size: string) => Cookies.set(sizeKey, size)

// User
//世彬要求，不用cookies存token
const tokenKey = 'qgj_user_token'
// export const getToken = () => Cookies.get(tokenKey)
// export const setToken = (token: string) => Cookies.set(tokenKey, token);
// export const removeToken = () => Cookies.remove(tokenKey)
export const getToken = () => localStorage.getItem(tokenKey)
export const setToken = (token: string) => localStorage.setItem(tokenKey, token);
export const removeToken = () => localStorage.removeItem(tokenKey)
